'use client';
import { ReactNode, useMemo, useState } from 'react';
import { CommonContext } from './commonContext';

export const CommonContentProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [disableElement, setDisableElement] = useState(false);
  const [disableNavigation, setDisableNavigation] = useState(false);
  const [modalWarningOpen, setModalWarningOpen] = useState(false);
  const value = useMemo(
    () => ({
      disableElement,
      setDisableElement,
      disableNavigation,
      setDisableNavigation,
      modalWarningOpen,
      setModalWarningOpen,
    }),
    [disableElement, disableNavigation, modalWarningOpen],
  );

  return (
    <CommonContext.Provider value={value}>{children}</CommonContext.Provider>
  );
};
